import React from 'react';
import uniqid from 'uniqid';
import { Link as RouterLink } from 'react-router-dom';


import { Box } from 'ui/box';

import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';
import Links from 'containers/user/learn/components/links/links';
import SeeAllButton from 'containers/user/learn/components/see-all-button/see-all-button';

interface CategoryContentItem {
  name?: string;
  coverDescription?: string;
  route: string;
  coverImage?: string;
}

interface CategoryContentProps {
  items: CategoryContentItem[];
  title: string;
  subtitle: string;
  categoryLink: string;
}

const CategoryContent = ({
  items,
  title,
  subtitle,
  categoryLink,
}: CategoryContentProps): React.JSX.Element => {
  const isArticle = title === 'Articles';

  return (
    <ResponsiveWrapper customClass="mobile:mt-12 xs:mt-20">
      <Box sx={{ color: 'tokens.navy.800', mb: 3 }}>
        <h2 className="text-4xl font-semibold mb-1">{title}</h2>
        <p className="font-semibold text-lg">{subtitle}</p>
      </Box>

      <Box
        sx={[
          !isArticle && {
            display: 'grid',
            gap: 3,
            '@media (min-width: 375px)': {
              gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
            },
            '@media (min-width: 780px)': {
              gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
            },
            '@media (min-width: 960px)': {
              gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
            },
            '@media (min-width: 1440px)': {
              gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
            },
          },
          isArticle && { width: '100%' },
        ]}
      >
        {!isArticle ? (
          items.map(({ name, coverDescription, route, coverImage }) => (
            <RouterLink
              to={route}
              key={uniqid()}
              className="border border-navy-200 rounded w-full"
            >
              {coverImage ? (
                <img
                  src={coverImage}
                  alt={`${title} ${name}`}
                  className="block w-full h-auto rounded-tl rounded-tr"
                />
              ) : (
                <div className="w-full aspect-[16/10] tablet:bg-bottom categories-bg rounded-tl rounded-tr"></div>
              )}
              <div className="text-neutral-900 text-xl font-semibold pt-4 px-4 pb-2">
                {name}
              </div>
              <div className="text-neutral-900 text-base px-4 pb-4">
                {coverDescription}
              </div>
            </RouterLink>
          ))
        ) : (
          <Links items={items} />
        )}
      </Box>

      <SeeAllButton route={categoryLink} contentType={title.toLowerCase()} />
    </ResponsiveWrapper>
  );
};

export default CategoryContent;
